import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { A as AccordionItem, g as getAccordionIconPositionDefault, b as getAccordionSizeDefault, a as getAccordionBackgroundColorDefault } from '../AccordionItem.esm.js';
import { AccordionContext } from '../AccordionContext/index.esm.js';
import '@skatteetaten/ds-icons';
import './styles.css';


var styles = {
    "accordion": "Accordion-module_accordion__gLedK",
    "accordion_forest": "Accordion-module_accordion_forest__CubI9",
    "accordion_denim": "Accordion-module_accordion_denim__seQKZ",
    "accordion_ochre": "Accordion-module_accordion_ochre__8dAzo",
    "accordion_burgundy": "Accordion-module_accordion_burgundy__N-moY",
    "accordion_graphite": "Accordion-module_accordion_graphite__XT07e"
};

const Accordion = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, color = getAccordionBackgroundColorDefault(), size = getAccordionSizeDefault(), iconPosition = getAccordionIconPositionDefault(), children }, ref)=>{
    const colorClassName = color !== 'none' ? styles[`accordion_${color}`] : '';
    const concatenatedClassNames = `${colorClassName} ${className}`.trim();
    return /*#__PURE__*/ jsx(AccordionContext.Provider, {
        value: {
            size,
            iconPosition
        },
        children: /*#__PURE__*/ jsx("div", {
            ref: ref,
            className: concatenatedClassNames,
            lang: lang,
            id: id,
            "data-testid": dataTestId,
            children: children
        })
    });
});
Accordion.displayName = 'Accordion';
Accordion.Item = AccordionItem;
Accordion.Item.displayName = 'Accordion.Item';

export { Accordion, getAccordionBackgroundColorDefault, getAccordionIconPositionDefault, getAccordionSizeDefault };
